export default "__VITE_ASSET__CJzhSDjm__"